import { AgreementPricingPayload, AgreementPricingResponse } from '~/types/ksa/AgreementPricing';
import axios from './axios';

const AGREEMENT_PRICING_URL = '/stages/ksa/contract/pricing';

/** Fetch current agreement pricing values, per-field thresholds and amendment status. */
export const getAgreementPricing = () =>
  axios.get<AgreementPricingResponse>(AGREEMENT_PRICING_URL).then((res) => res.data);

/** Submit amended agreement pricing for Sales Manager approval. */
export const submitAgreementPricing = (payload: AgreementPricingPayload) =>
  axios.post<AgreementPricingResponse>(AGREEMENT_PRICING_URL, payload).then((res) => res.data);

/** Approve the pending amendment for the currently-selected application (nogo-manager) and apply
 *  it. Pass `payload` when the manager has amended fees before approving. The target application
 *  is resolved server-side from the Application-Id header, same as every other stage endpoint. */
export const approveAgreementPricing = (payload?: AgreementPricingPayload) =>
  axios
    .post<AgreementPricingResponse>(`${AGREEMENT_PRICING_URL}/approve`, payload ?? {})
    .then((res) => res.data);

/** Reject the pending amendment for the currently-selected application (nogo-manager), returning
 *  it to the agent. */
export const rejectAgreementPricing = (rejectionReason: string) =>
  axios
    .post<AgreementPricingResponse>(`${AGREEMENT_PRICING_URL}/reject`, { rejectionReason })
    .then((res) => res.data);
